import { enFooter } from '../en';
import { frFooter } from '../fr';
import { esFooter } from '../es';
import { deFooter } from '../de';

export const footerModuleTranslations = {
  en: enFooter,
  fr: frFooter,
  es: esFooter,
  de: deFooter,
} as const;

